export default __webpack_public_path__ + "static/media/DGB_LI.e9f75278.png";